import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useAppSelector } from '../../redux/store';
import { MyBombAmmoDisplay } from './myBombAmmoDisplay';
/**
 * Renders your ammo count only if the provided player is sitting.
 */
export const MyBombAmmoDisplaySeatedPlayerWrapper = ({ playerId }) => {
    const isSeatedPlayer = useAppSelector((state) => Object.values(state.poker.seatedPlayers).findIndex((seatedPlayer) => seatedPlayer?.id === playerId) !== -1);
    if (!isSeatedPlayer) {
        return null;
    }
    return _jsx(MyBombAmmoDisplay, {});
};
